module.exports = __webpack_public_path__ + "static/media/carta_94.09e92994.jpg";